import * as ActionTypes from './actionTypes'
import {createAction} from 'redux-actions'

export const toggleAddonsMenu = createAction(ActionTypes.ADDONS_MENU_TOGGLE)
export const closeAddonsMenu = createAction(ActionTypes.ADDONS_MENU_CLOSE)



// WEBPACK FOOTER //
// ./web/js/support/addons/actions.js